<form class="forms" [formGroup]="referenciaForm">
  <div class="input-multi">
    <select
        class="form-control select-small"
        name="tipoReferencia"
        formControlName="tipoReferencia"
        required
        appShowErrorMessages
        requiredMessage="O campo Tipo de Referência é Obrigatório">
      <option value="1" selected>Amigo(a)</option>
      <option value="2">Parente</option>
      <option value="3">Vizinho(a)</option>
      <option value="4">Outros</option>
    </select>
    <div class="input-multi-container">
      <div class="removable-container">
        <div style="width: 100%">
          <input
              class="form-control"
              type="text"
              placeholder="Nome da Referência"
              name="nomeReferencia"
              formControlName="nomeReferencia"
              maxlength="40"
              appShowErrorMessages
              requiredMessage="O campo Nome da Referência é Obrigatório">
          <input
              class="form-control"
              type="text"
              placeholder="(00) 00000-0000"
              name="telefoneReferencia"
              [minLength]="10"
              [maxLength]="11"
              formControlName="telefoneReferencia"
              appOnlyDigitsLengthValidator
              appShowErrorMessages
              requiredMessage="O campo Telefone da Referência é Obrigatório"
              inputmode="numeric"
              appOnlyNumberRestrictive
              [value]="referenciaForm.get('telefoneReferencia').value | telefone">
        </div>
        <p class="remove-item-btn" (click)="selfDestruct()" *ngIf="isRemovable"><em class="fa fa-trash"></em></p>
      </div>
    </div>
  </div>
</form>
